export default "__VITE_ASSET__Cto$SP92__"